import { supabase } from '../supabase/supabase';

const normalizeUser = user => ({
  id: user?.id || user?.user_id || '',
  user_id: user?.user_id || user?.id || '',
  tenant_id: user?.tenant_id || '',
  name: user?.name || '',
  email: user?.email || '',
  role: user?.role || '',
  status: user?.status || '',
  department: user?.department || '',
  avatar: user?.avatar || ''
});

export const listTenantUsers = async tenantId => {
  if (!tenantId) {
    return {
      success: false,
      data: [],
      error: 'Missing tenantId'
    };
  }

  const { data, error } = await supabase.rpc('get_tenant_team_users', {
    p_tenant_id: tenantId
  });

  if (error) {
    console.error('[TeamService] Could not load tenant users', error);

    return {
      success: false,
      data: [],
      error: error.message || String(error)
    };
  }

  return {
    success: true,
    data: (data || []).map(normalizeUser),
    error: null
  };
};